import axios from 'axios'

let intervalID = -1

globalThis.devEnvironment = false 

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

import Vue from 'vue';
async function updateToken(): Promise<string> {
  return Vue.$keycloak.updateToken(70).then((result: boolean) => {    
    return Vue.$keycloak.token as string;
  }).catch(() => {    
    return Vue.$keycloak.token as string;
  })
}


apiClient.interceptors.response.use(async function(response) {
  if (response.status == 202) {
    /*      console.log('HTTP 202 received, polling operation...')
    console.log('Operation running at ' + response.headers.location) */
    let pollingResponse = await apiClient.get(response.headers.location)
    //console.log('Operation status is ' + pollingResponse.data.status)

    await new Promise<void>((resolve) => {
      intervalID = setInterval(async function() {
        try{
          pollingResponse = await apiClient.get(response.headers.location)            
        }catch(e) {
          clearInterval(intervalID)
          resolve()
        }
        console.log('Operation status is ' + pollingResponse.data.status)
        if (pollingResponse.data.status==='FAILURE') {
          console.log("FAILED: ",pollingResponse.data)
        }
        if (
          pollingResponse.data.status === 'SUCCESS' ||
          pollingResponse.data.status === 'FAILURE'
        ) {
          clearInterval(intervalID)
          resolve()
        }
      }, 1000)
    })

    /*     console.log(
      'Operation completed, status is ' + pollingResponse.data.status
    ) */

    if (pollingResponse.data.status === 'FAILED') {
      throw 'Operation failed!'
    } else {
      if(pollingResponse.headers.resourcelocation==undefined){
        return pollingResponse
      }else{
      //console.log('headers ' + JSON.stringify(pollingResponse.headers))
      //console.log('resource url ' + pollingResponse.headers.resourcelocation)
        return await apiClient.get(pollingResponse.headers.resourcelocation)
      }
    }
  } else {
    return response
  }
})

apiClient.interceptors.request.use(async config => {
  console.log("in interceptor")
  const token = await updateToken();
  config.headers.common['Authorization'] = `Bearer ${token}`
  return config
})
  
  

export default {
  setAuthHeader(idToken) {
    apiClient.defaults.headers['Authorization'] = 'Bearer ' + idToken
  },
  getDBNames(): Promise<any> {
    return apiClient.get('database_names')
  },
  getConfigurationList(db: string): Promise<any> {
    return apiClient.get('listcfgs?db=' + db)
  },
  getCfgFromFileOrLocalServer(): Promise<any> {
    console.log('getCfgFromFileOrLocalServer CALLED!')
    return apiClient.get('cfg')
  },
  getMetadataFromFileOrLocalServer(): Promise<any> {
    console.log('getMetadataFromFileOrLocalServer CALLED!')
    return apiClient.get('metadata')
  },
  getConfigurationByName(cfg: string, db: string): Promise<any> {
    return apiClient.get('cfg', {
      params: {
        cfg: cfg,
        db: db,
      },
    })
  },
  getConfigFromLocalFile(fileData): Promise<any> {
    let jsonObject = JSON.parse(fileData)
    return jsonObject['configuration']
  },
  getConfigListFromLocalFile(fileData): Promise<any> {
    let jsonObject = JSON.parse(fileData)
    return jsonObject['configuration_list']
  },
  postAll(all): Promise<any> {
    return apiClient.post('/', all)
  },
  getDiff(to_cfg : string ,from_cfg : string) : Promise<any> {
    return apiClient.get('diff',{
      params : {
        to_cfg : to_cfg,
        from_cfg : from_cfg
      }
    })
  },
  getPathL1Seeds(cfg : string) : Promise<any> {
    return apiClient.get('pathl1seeds',{
      params : {
        cfg : cfg,        
      }
    })
  }
}
